"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "gagliano-del-capo": {
    "25ac83a4": [{
      "hkey": "41eaf61c",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "arigliano": [{
      "hkey": "41eaf61c",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "gagliano-del-capo"
    }]
  }
};
exports["default"] = _default;